import { useMatches } from "@tanstack/react-router"

import HeaderTabs, { getActiveTab } from "~/components/reusable/HeaderTabs"
import { useInspectorContext } from "~/components/design-system/pages/internal/InspectorContext"
import InspectorToggleButton from "~/components/design-system/pages/internal/InspectorToggleButton"
import { type ModuleTabsConfig } from "~/components/design-system/pages/types"
import { usePublishNavContext } from "~/stores/nav-context-store"

const ModuleTabs = ({ items, path, actions }: ModuleTabsConfig) => {
  const { inspector, viewConfiguration } = useInspectorContext()
  const fullPath = useMatches({ select: (matches) => matches[matches.length - 1]?.fullPath })
  // The active tab's label is page context for sidebar favorites.
  usePublishNavContext("tabLabel", getActiveTab(items, fullPath)?.label)
  // Fallback toggle lives here only when an inspector exists but there's no
  // ViewConfiguration to host it (the VC renders its own toggle).
  const showToggle = !!inspector && !viewConfiguration

  if (!showToggle && !actions) return <HeaderTabs tabs={items} path={path} />

  return (
    <div className="flex w-full items-center border-b border-base">
      <HeaderTabs tabs={items} path={path} containerClassName="flex-1 border-b-0" />
      <div className="flex items-center gap-2 pr-4">
        {actions}
        {showToggle && <InspectorToggleButton />}
      </div>
    </div>
  )
}

export default ModuleTabs
